import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AdminUserService, ApplicationUserApi } from '../../../../services/admin-user.service';

@Component({
  selector: 'app-user-notification-settings',
  templateUrl: './user-notification-settings.component.html',
  styleUrls: ['./user-notification-settings.component.scss']
})
export class UserNotificationSettingsComponent implements OnInit, OnDestroy {

  formGroup: FormGroup = null;

  currentUser: ApplicationUserApi;

  formInProgress: boolean = false;

  unsubscribe: Subject<any> = new Subject;

  constructor(
    private userService: AdminUserService
  ) {
    this.formGroup = new FormGroup({
      userId: new FormControl(null, []),
      userEmail: new FormControl(null, [
        Validators.required,
        Validators.email
      ])
    });
  }

  ngOnInit() {
    this.userService.getCurrentUser();

    this.userService.currentUser
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(currentUser => {
        if (!!currentUser) {
          this.currentUser = currentUser;
          this.formGroup.setValue({
            userId: currentUser.id,
            userEmail: currentUser.email
          });
        }
      });
  }

  onSubmit() {
    console.log(`Form submitted`)
    if (this.formHasErrors()) { return; }

    this.formInProgress = true;

    this.currentUser.email = this.formGroup.get('userEmail').value;
    this.userService.updateCurrentUser(this.currentUser);

    this.formInProgress = false;
  }

  formHasErrors() {
    var formId = this.formUserId();
    if (!!formId.errors) { return true; }
    var formEmail = this.formUserEmail();
    if (!!formEmail.errors && (formEmail.errors.required || formEmail.errors.email)) { return true; }
    return false;
  }

  formUserId() {
    return this.formGroup.get('userId');
  }

  formUserEmail() {
    return this.formGroup.get('userEmail');
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
